<survey *ngIf="!hideSurvey"
  id="surveyElement"
  [model]="surveyModel"></survey>